export default function CtaBanner() {
  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <div className="max-w-6xl mx-auto relative rounded-lg overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=wide%20abstract%20dark%20background%20with%20warm%20amber%20and%20deep%20red%20gradient%20waves%20and%20glowing%20light%20particles%2C%20premium%20cinematic%20texture%2C%20no%20text%2C%20soft%20organic%20shapes&width=1600&height=500&seq=ppsp-cta-01&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40"></div>
        <div className="relative z-10 px-6 md:px-12 py-12 md:py-16">
          <h2 className="font-heading text-background-50 text-3xl md:text-5xl tracking-wide">
            换地址不迷路，收藏本页即可
          </h2>
          <p className="mt-4 max-w-xl text-background-100 text-sm md:text-base leading-relaxed">
            手机版安装包与最新地址都会在此页面同步更新。需要时直接返回这里，选择下载或在线访问即可。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a
              href="#download"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors text-sm md:text-base whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line text-lg"></i>
              选择下载方式
            </a>
            <a
              href="#address"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/40 text-background-50 hover:bg-background-50/10 transition-colors text-sm md:text-base whitespace-nowrap cursor-pointer"
            >
              <i className="ri-links-line text-lg"></i>
              查看全部线路
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}